import React, { useEffect, useState, useMemo, useRef } from "react";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Autocomx from "../Autocomx";
import Excelxxx from "../Excelxxx";
import { useLazyGetCimaDirectorProviderQuery} from "../../libs/redux/slices/cimaxxxx/cimaxxxxApiSlice";
import { useLazyGetFacturaQuery } from "../../libs/redux/slices/autocomxSlice/autocomxApiSlice";

// Constante de modulo: reglas estables (evita re-ejecutar el efecto y cancelar el debounce).
const oFacturaRulesByMetaId = {
  NUMFACXX: { sourceField: "NUMPEDXX", minLength: 4, blockedValues: ["getfactura"] },
};

const Metadata = ({ GEST0004, setJsonmetx, inputValue, jsonmetx }) => {
  let cObject = "";
  let bRequired = GEST0004.BANOBLXX === "SI" ? true : false;
  let cLabel = bRequired ? GEST0004.METDESXX + " *" : GEST0004.METDESXX;
  let objectMetadata = { ...GEST0004 };
  const [findCimaDirectionProviders] = useLazyGetCimaDirectorProviderQuery();
  const [findFactura] = useLazyGetFacturaQuery();
  const [options, setOptions] = useState([]);
  const [isLoadingFactura, setIsLoadingFactura] = useState(false);
  const oFacturaRule = oFacturaRulesByMetaId[objectMetadata.METIDXXX];
  const bIsFacturaMeta = !!oFacturaRule;
  const cSourceFieldFactura = oFacturaRule?.sourceField ?? "NUMPEDXX";
  const cTargetFieldFactura = objectMetadata.METIDXXX;
  const bIsFacturaNumericField =
    objectMetadata.METTIPXX === "NUMERO" && bIsFacturaMeta;
  const pedidoForFacturaEffect = bIsFacturaNumericField ? String(jsonmetx?.[cSourceFieldFactura] ?? "").trim() : null;
  const jsonmetxRef = useRef(jsonmetx);
  const setJsonmetxRef = useRef(setJsonmetx);
  jsonmetxRef.current = jsonmetx;
  setJsonmetxRef.current = setJsonmetx;

// Mapeo de campos a sus respectivos endpoints y valores a concatenar
const endpoints = useMemo(() => ({
  DIRECPRO: {
    query: findCimaDirectionProviders,
    values: ['DIRECPRO','CLIPROCB', 'APLVECIX', 'PIEIDXXX', 'PAIIDXXX', 'DEPIDXXX', 'CIUIDXXX'],
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), []);

  //Hook encargado de consultar los Metadatos tipo Select que cuentan con Funcion
  useEffect(() => {
    if (endpoints[GEST0004.METIDXXX]) {
      const endpoint = endpoints[GEST0004.METIDXXX];
      switch (GEST0004.METIDXXX) {
        case "PRSIDIREC":
        case "DIRECPRO":
          if (jsonmetx.CLIIDXXX && jsonmetx.PROIDXXX) {
            const filterEmpresa = `filters[CLIIDXXX]=${jsonmetx.CLIIDXXX}&filters[IDPROXXX]=${jsonmetx.PROIDXXX}`;
            endpoint.query(filterEmpresa)
              .then((response) => {
                if (response?.data?.data) {
                  const formatData = response.data.data.map((direction) => {
                    const valuesToUse = endpoint.values.map(val => {
                      return val === 'DIRECPRO' && direction.PRODIRXX ? direction.PRODIRXX : direction[val] || '';
                    });
                    const value = valuesToUse.join(',-,');
                    return {
                      value,
                      label: direction.PRODIRXX,
                    };
                  });
                  setOptions(formatData);
                }
              })
              .catch(() => {
                setOptions([]);
              });
          }
          break;
        default:
          break;
      }
    }

    if (objectMetadata.METIDXXX === "USERDIFE" && (jsonmetx[objectMetadata.METIDXXX] === "" || jsonmetx[objectMetadata.METIDXXX] === undefined)) {
      setJsonmetx(objectMetadata.METIDXXX, "NO", "NO");
    }
    // eslint-disable-next-line
  }, [jsonmetx, endpoints, GEST0004]);

  // Autollenado de factura para metadatos y tipo especifico
  useEffect(() => {
    if (!bIsFacturaNumericField) {
      return;
    }

    const cPedido = pedidoForFacturaEffect;
    const setFacturaIfChanged = (cNewValue) => {
      const jsonmetxActual = jsonmetxRef.current;
      const cValorActual =
        jsonmetxActual && jsonmetxActual[cTargetFieldFactura] ? jsonmetxActual[cTargetFieldFactura] : "";
      if (cValorActual !== cNewValue) {
        setJsonmetxRef.current(cTargetFieldFactura, cNewValue);
      }
    };

    if (cPedido === "") {
      setIsLoadingFactura(false);
      setFacturaIfChanged("");
      return;
    }

    // Evita consultar por valores temporales y reduce llamadas mientras el usuario escribe.
    const cPedidoLower = cPedido.toLowerCase();
    const nMinLength = oFacturaRule && oFacturaRule.minLength ? oFacturaRule.minLength : 4;
    const aBlockedValues =
      oFacturaRule && Array.isArray(oFacturaRule.blockedValues) ? oFacturaRule.blockedValues : [];
    const bIsBlocked = aBlockedValues.map((cVal) => String(cVal).toLowerCase()).includes(cPedidoLower);
    const bPedidoValido = cPedido.length >= nMinLength && !bIsBlocked;
    if (!bPedidoValido) {
      setIsLoadingFactura(false);
      setFacturaIfChanged("");
      return;
    }

    let cancelled = false;
    const timeoutId = setTimeout(() => {
      setIsLoadingFactura(true);
      findFactura(cPedido)
        .then((response) => {
          if (cancelled) return;
          const aFacturas = response && response.data && response.data.data ? response.data.data : [];
          // La API usa LIKE pedido%; puede venir mas de una fila. Solo usar factura si numordco coincide exactamente con el pedido.
          let cFactura = "";
          for (let i = 0; i < aFacturas.length; i++) {
            const mRow = aFacturas[i];
            const cOrd =
              mRow && mRow.numordco !== undefined && mRow.numordco !== null ? String(mRow.numordco).trim().toLowerCase() : "";
            if (cOrd === cPedidoLower) {
              cFactura =
                mRow && mRow.numfactx !== undefined && mRow.numfactx !== null ? String(mRow.numfactx) : "";
              break;
            }
          }
          setFacturaIfChanged(cFactura);
        })
        .catch(() => {
          if (cancelled) return;
          setFacturaIfChanged("");
        })
        .finally(() => {
          if (cancelled) return;
          setIsLoadingFactura(false);
        });
    }, 350);

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
      setIsLoadingFactura(false);
    };
  }, [
    bIsFacturaNumericField,
    pedidoForFacturaEffect,
    cTargetFieldFactura,
    oFacturaRule,
    findFactura,
  ]);

  switch (objectMetadata.METTIPXX) {
    case "BOOLEANO":
      cObject = (
        <Form.Check
          type="checkbox"
          name={objectMetadata.METIDXXX}
          label={cLabel}
          required={bRequired}
          onChange={(e) => {
            const key = objectMetadata.METIDXXX;
            setJsonmetx(key, e.target.value);
          }}
        ></Form.Check>
      );
      break;
    case "NUMERO":
    case "TEXTO":
      let type = objectMetadata.METTIPXX === "NUMERO" ? "number" : "text";
      const bIsFacturaField = objectMetadata.METTIPXX === "NUMERO" && bIsFacturaMeta;
      const cFieldValue =
        inputValue && inputValue[objectMetadata.METIDXXX] ? inputValue[objectMetadata.METIDXXX] : "";
      const cFieldClassName = bIsFacturaField ? "pe-5" : "";
      cObject = (
        <>
          <Form.Label>{cLabel}</Form.Label>
          {bIsFacturaField ? (
            <div className="position-relative">
              <Form.Control
                value={cFieldValue}
                type={type}
                name={objectMetadata.METIDXXX}
                required={bRequired}
                className={cFieldClassName}
                onChange={(e) => {
                  const key = objectMetadata.METIDXXX;
                  setJsonmetx(key, e.target.value);
                }}
              />
              {isLoadingFactura && (
                <div className="position-absolute top-50 end-0 translate-middle-y me-2 pe-none">
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    className="text-secondary"
                  />
                </div>
              )}
            </div>
          ) : (
            <Form.Control
              value={cFieldValue}
              type={type}
              name={objectMetadata.METIDXXX}
              required={bRequired}
              className={cFieldClassName}
              onChange={(e) => {
                const key = objectMetadata.METIDXXX;
                setJsonmetx(key, e.target.value);
              }}
            ></Form.Control>
          )}
        </>
      );
      break;
    case "FECHA":
      cObject = (
        <>
          <Form.Label>{cLabel}</Form.Label>
          <Form.Control
            value={inputValue && inputValue[objectMetadata.METIDXXX] ? inputValue[objectMetadata.METIDXXX] : ""}
            required={bRequired}
            type="date"
            name={objectMetadata.METIDXXX}
            onChange={(e) => {
              if (e.target.value !== "") {
                const key = objectMetadata.METIDXXX;
                setJsonmetx(key, e.target.value);
                e.target.value = e.target.value.split("/").reverse().join("-");
              }
            }}
          ></Form.Control>
        </>
      );
      break;
      case "LISTASELECCION":
        if (endpoints[GEST0004.METIDXXX]) {
          const result = endpoints[GEST0004.METIDXXX].values
            .map(val => jsonmetx[val] || '')
            .join(',-,');
          cObject = (
            <>
              <Form.Label>{cLabel}</Form.Label>
              <Form.Select
                value={result || ""}
                required={bRequired}
                name={GEST0004.METIDXXX}
                onChange={(e) => {
                  const key = GEST0004.METIDXXX;
                  setJsonmetx(key, e.target.value);
                }}
              >
                <option value="">[SELECCIONE]</option>
                {options.map((option, key) => (
                  <option value={option.value} key={`option-${GEST0004.METIDXXX}-${key}`}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </>
          );
        } else {
          // CAPDAFAC y USERDIFE deben reflejar siempre el estado actual de jsonmetx.
          const bIsSpecialMeta = objectMetadata.METIDXXX === "CAPDAFAC" || objectMetadata.METIDXXX === "USERDIFE";
          const cSpecialValue = jsonmetx && jsonmetx[objectMetadata.METIDXXX] ? jsonmetx[objectMetadata.METIDXXX] : "";
          const cNormalValue =  inputValue && inputValue[objectMetadata.METIDXXX] ? inputValue[objectMetadata.METIDXXX] : "";
          const cSelectValue = bIsSpecialMeta ? cSpecialValue : cNormalValue;
          cObject = (
            <>
              <Form.Label>{cLabel}</Form.Label>
              <Form.Select
                value={cSelectValue}
                required={bRequired}
                name={GEST0004.METIDXXX}
                onChange={(e) => {
                  const key = GEST0004.METIDXXX;
                  setJsonmetx(key, e.target.value);
                }}
              >
                <option value="">[SELECCIONE]</option>
                {GEST0004.METOPXXX.split(",").map((option, key) => (
                  <option value={option} key={`option-${GEST0004.METIDXXX}-${key}`}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </>
          );
        }
        break;
    case "LISTASELECCIONFUNCION":
      cObject = (
        <>
          <Form.Label>{cLabel}</Form.Label>
          <Autocomx
            objectMetadata={objectMetadata}
            setJsonmetx={setJsonmetx}
            isMultiple={false}
            inputValue={inputValue}
            bRequired={bRequired}
            jsonmetx={jsonmetx}
          />
        </>
      );
      break;
    case "LISTASELECCIONFUNCIONMULTIPLE":
      cObject = (
        <>
          <Form.Label>{cLabel}</Form.Label>
          <Autocomx
            objectMetadata={objectMetadata}
            setJsonmetx={setJsonmetx}
            isMultiple={true}
            inputValue={inputValue}
            bRequired={bRequired}
            jsonmetx={jsonmetx}
          />
        </>
      );
      break;
    case "HORA":
      cObject = (
        <>
          <Form.Label>{cLabel}</Form.Label>
          <Form.Control
            value={inputValue && inputValue[objectMetadata.METIDXXX] ? inputValue[objectMetadata.METIDXXX] : ""}
            required={bRequired}
            type="time"
            name={objectMetadata.METIDXXX}
            onChange={(e) => {
              if (e.target.value !== "") {
                const key = objectMetadata.METIDXXX;
                setJsonmetx(key, e.target.value);
                e.target.value = e.target.value.split("/").reverse().join("-");
              }
            }}
          ></Form.Control>
        </>
      );
      break;
      case "EXCEL":
        cObject = (
          <>
            <Form.Label>{cLabel}</Form.Label>
            <Excelxxx
              objectMetadata={objectMetadata}
              setJsonmetx={setJsonmetx}
              isMultiple={false}
              inputValue={inputValue}
              bRequired={bRequired}
              jsonmetx={jsonmetx}
            />
          </>
        );
        break;
    default:
      cObject = "";
      break;
  }
  return cObject;
};

export default Metadata;
